// Fixed, professionally-written interface translations for MR SHU Handyman Quote.
// Supported: English (en), Simplified Chinese (zh-CN), Traditional Chinese (zh-TW), Korean (ko).

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "zh-CN", label: "简体中文", short: "简" },
  { code: "zh-TW", label: "繁體中文", short: "繁" },
  { code: "ko", label: "한국어", short: "한" },
];

// English names used in the (English-only) admin dashboard.
export const LANG_ENGLISH_NAME = {
  en: "English",
  "zh-CN": "Simplified Chinese",
  "zh-TW": "Traditional Chinese",
  ko: "Korean",
};

const STRINGS = {
  en: {
    back: "Back",
    logout: "Log out",
    app_tagline: "Fast, reliable quotes for repairs, renovations & property maintenance across Christchurch.",
    login: "Log in",
    register: "Register",
    admin_link: "Business owner? Admin sign in",
    handyman_quote: "Handyman Quote",
    welcome_back: "Welcome back",

    create_account: "Create account",
    full_name: "Full name",
    full_name_ph: "e.g. Sarah Wilson",
    mobile_number: "Mobile phone number",
    mobile_number_short: "Mobile number",
    mobile_ph: "e.g. 021 234 5678",
    login_account_note: "This is your login account.",
    job_address: "Job address",
    address_ph: "Start typing your Christchurch address",
    create_pin: "Create a 4-digit PIN",
    pin_label: "4-digit PIN",
    send_code: "Send verification code",
    code_sent_to: "We sent a 6-digit code to {phone}.",
    demo_code: "Demo mode code",
    verification_code: "Verification code",
    code_ph: "6-digit code",
    verify_create: "Verify & create account",
    new_customer_register: "New customer? Register here",
    forgot_pin: "Forgot your PIN?",
    forgot_desc: "Enter your mobile number and we'll send a verification code to reset your PIN.",
    new_pin_label: "New 4-digit PIN",
    verify_reset: "Verify & reset PIN",
    verify_continue: "Verify & continue",
    verify_your_mobile: "Verify your mobile",
    migrate_title: "One-time security verification",
    migrate_desc: "For your security we now verify your mobile by SMS. Tap below to receive a code.",
    resend_code: "Resend code",
    resend_in: "Resend in {s}s",
    complete_security_check: "Please complete the security check",

    err_name: "Please enter your full name",
    err_phone: "Please enter a valid mobile number",
    err_address: "Please enter your job address",
    err_pin4: "PIN must be exactly 4 digits",
    toast_code_sent: "Verification code sent",
    err_code6: "Enter the 6-digit code",
    toast_account_created: "Account created!",
    err_enter_mobile: "Enter your mobile number",
    err_enter_pin: "Enter your 4-digit PIN",
    welcome_name: "Welcome back, {name}!",

    signed_in: "Signed in",
    how_urgent: "How urgent is your job?",
    choose_to_start: "Choose one to start your quote request.",
    urgent: "Urgent",
    urgent_desc: "Needs attention as soon as possible",
    not_urgent: "Not Urgent",
    not_urgent_desc: "Flexible timing works fine",

    quote_request: "Quote request",
    required_note: "Only type of work, completion time & address are required.",
    type_of_work: "Type of work",
    preferred_time: "Preferred completion time",
    budget_label: "Estimated budget (NZD)",
    optional: "— optional",
    budget_ph: "e.g. $500",
    description_label: "Job description",
    description_ph: "Tell us more about the job...",
    photos_videos: "Photos & videos",
    tap_add_media: "Tap to add photos or videos",
    uploading: "Uploading...",
    submit_request: "Submit Quote Request",
    err_select_work: "Please select a type of work",
    err_select_time: "Please select a preferred completion time",
    err_confirm_address: "Please confirm your job address",

    request_received: "Request received",
    thanks_touch: "Thanks! MR SHU will be in touch shortly.",
    job_reference: "Job reference number",
    urgency: "Urgency",
    uploaded_files: "Uploaded files",
    files_count: "{n} file(s)",
    submit_another: "Submit another request",
    back_home: "Back home",

    required_mark: "*",
  },

  "zh-CN": {
    back: "返回",
    logout: "退出登录",
    app_tagline: "为基督城的维修、翻新和物业维护提供快速可靠的报价。",
    login: "登录",
    register: "注册",
    admin_link: "商家？管理员登录",
    handyman_quote: "维修报价",
    welcome_back: "欢迎回来",

    create_account: "创建账户",
    full_name: "全名",
    full_name_ph: "例如：张伟",
    mobile_number: "手机号码",
    mobile_number_short: "手机号码",
    mobile_ph: "例如：021 234 5678",
    login_account_note: "这是您的登录账号。",
    job_address: "工作地址",
    address_ph: "请输入您的基督城地址",
    create_pin: "设置 4 位数字密码",
    pin_label: "4 位数字密码",
    send_code: "发送验证码",
    code_sent_to: "我们已向 {phone} 发送 6 位验证码。",
    demo_code: "演示模式验证码",
    verification_code: "验证码",
    code_ph: "6 位验证码",
    verify_create: "验证并创建账户",
    new_customer_register: "新客户？点此注册",
    forgot_pin: "忘记密码？",
    forgot_desc: "输入您的手机号码，我们将发送验证码以重置密码。",
    new_pin_label: "新的 4 位数字密码",
    verify_reset: "验证并重置密码",
    verify_continue: "验证并继续",
    verify_your_mobile: "验证您的手机",
    migrate_title: "一次性安全验证",
    migrate_desc: "为了您的账户安全，我们现在通过短信验证您的手机。点击下方接收验证码。",
    resend_code: "重新发送验证码",
    resend_in: "{s} 秒后可重新发送",
    complete_security_check: "请完成安全验证",

    err_name: "请输入您的全名",
    err_phone: "请输入有效的手机号码",
    err_address: "请输入您的工作地址",
    err_pin4: "密码必须是 4 位数字",
    toast_code_sent: "验证码已发送",
    err_code6: "请输入 6 位验证码",
    toast_account_created: "账户创建成功！",
    err_enter_mobile: "请输入手机号码",
    err_enter_pin: "请输入 4 位数字密码",
    welcome_name: "欢迎回来，{name}！",

    signed_in: "已登录",
    how_urgent: "您的工作有多紧急？",
    choose_to_start: "请选择一项以开始报价申请。",
    urgent: "紧急",
    urgent_desc: "需要尽快处理",
    not_urgent: "不紧急",
    not_urgent_desc: "时间灵活即可",

    quote_request: "报价申请",
    required_note: "仅工作类型、完成时间和地址为必填项。",
    type_of_work: "工作类型",
    preferred_time: "期望完成时间",
    budget_label: "预算估计（新西兰元）",
    optional: "— 可选",
    budget_ph: "例如：$500",
    description_label: "工作描述",
    description_ph: "请告诉我们更多工作详情……",
    photos_videos: "照片和视频",
    tap_add_media: "点击添加照片或视频",
    uploading: "上传中……",
    submit_request: "提交报价申请",
    err_select_work: "请选择工作类型",
    err_select_time: "请选择期望完成时间",
    err_confirm_address: "请确认您的工作地址",

    request_received: "申请已收到",
    thanks_touch: "谢谢！MR SHU 将尽快与您联系。",
    job_reference: "工作参考编号",
    urgency: "紧急程度",
    uploaded_files: "已上传文件",
    files_count: "{n} 个文件",
    submit_another: "提交另一个申请",
    back_home: "返回首页",

    required_mark: "*",
  },

  "zh-TW": {
    back: "返回",
    logout: "登出",
    app_tagline: "為基督城的維修、翻新及物業維護提供快速可靠的報價。",
    login: "登入",
    register: "註冊",
    admin_link: "商家？管理員登入",
    handyman_quote: "維修報價",
    welcome_back: "歡迎回來",

    create_account: "建立帳戶",
    full_name: "全名",
    full_name_ph: "例如：陳大文",
    mobile_number: "手機號碼",
    mobile_number_short: "手機號碼",
    mobile_ph: "例如：021 234 5678",
    login_account_note: "這是您的登入帳號。",
    job_address: "工作地址",
    address_ph: "請輸入您的基督城地址",
    create_pin: "設定 4 位數字密碼",
    pin_label: "4 位數字密碼",
    send_code: "發送驗證碼",
    code_sent_to: "我們已向 {phone} 發送 6 位驗證碼。",
    demo_code: "示範模式驗證碼",
    verification_code: "驗證碼",
    code_ph: "6 位驗證碼",
    verify_create: "驗證並建立帳戶",
    new_customer_register: "新客戶？按此註冊",
    forgot_pin: "忘記密碼？",
    forgot_desc: "輸入您的手機號碼，我們將發送驗證碼以重設密碼。",
    new_pin_label: "新的 4 位數字密碼",
    verify_reset: "驗證並重設密碼",
    verify_continue: "驗證並繼續",
    verify_your_mobile: "驗證您的手機",
    migrate_title: "一次性安全驗證",
    migrate_desc: "為了您的帳戶安全，我們現在透過短訊驗證您的手機。按下方接收驗證碼。",
    resend_code: "重新發送驗證碼",
    resend_in: "{s} 秒後可重新發送",
    complete_security_check: "請完成安全驗證",

    err_name: "請輸入您的全名",
    err_phone: "請輸入有效的手機號碼",
    err_address: "請輸入您的工作地址",
    err_pin4: "密碼必須是 4 位數字",
    toast_code_sent: "驗證碼已發送",
    err_code6: "請輸入 6 位驗證碼",
    toast_account_created: "帳戶建立成功！",
    err_enter_mobile: "請輸入手機號碼",
    err_enter_pin: "請輸入 4 位數字密碼",
    welcome_name: "歡迎回來，{name}！",

    signed_in: "已登入",
    how_urgent: "您的工作有多緊急？",
    choose_to_start: "請選擇一項以開始報價申請。",
    urgent: "緊急",
    urgent_desc: "需要盡快處理",
    not_urgent: "不緊急",
    not_urgent_desc: "時間彈性即可",

    quote_request: "報價申請",
    required_note: "僅工作類型、完成時間及地址為必填項。",
    type_of_work: "工作類型",
    preferred_time: "期望完成時間",
    budget_label: "預算估計（紐元）",
    optional: "— 選填",
    budget_ph: "例如：$500",
    description_label: "工作描述",
    description_ph: "請告訴我們更多工作詳情……",
    photos_videos: "照片和影片",
    tap_add_media: "點擊新增照片或影片",
    uploading: "上傳中……",
    submit_request: "提交報價申請",
    err_select_work: "請選擇工作類型",
    err_select_time: "請選擇期望完成時間",
    err_confirm_address: "請確認您的工作地址",

    request_received: "申請已收到",
    thanks_touch: "謝謝！MR SHU 將盡快與您聯絡。",
    job_reference: "工作參考編號",
    urgency: "緊急程度",
    uploaded_files: "已上傳檔案",
    files_count: "{n} 個檔案",
    submit_another: "提交另一個申請",
    back_home: "返回首頁",

    required_mark: "*",
  },

  ko: {
    back: "뒤로",
    logout: "로그아웃",
    app_tagline: "크라이스트처치 전역의 수리, 리노베이션 및 자산 관리를 위한 빠르고 신뢰할 수 있는 견적.",
    login: "로그인",
    register: "회원가입",
    admin_link: "사업주이신가요? 관리자 로그인",
    handyman_quote: "수리 견적",
    welcome_back: "다시 오신 것을 환영합니다",

    create_account: "계정 만들기",
    full_name: "성명",
    full_name_ph: "예: 홍길동",
    mobile_number: "휴대폰 번호",
    mobile_number_short: "휴대폰 번호",
    mobile_ph: "예: 021 234 5678",
    login_account_note: "이 번호가 로그인 계정입니다.",
    job_address: "작업 주소",
    address_ph: "크라이스트처치 주소를 입력하세요",
    create_pin: "4자리 PIN 만들기",
    pin_label: "4자리 PIN",
    send_code: "인증번호 전송",
    code_sent_to: "{phone} (으)로 6자리 인증번호를 보냈습니다.",
    demo_code: "데모 모드 인증번호",
    verification_code: "인증번호",
    code_ph: "6자리 인증번호",
    verify_create: "인증 후 계정 만들기",
    new_customer_register: "신규 고객이신가요? 여기서 가입하세요",
    forgot_pin: "PIN을 잊으셨나요?",
    forgot_desc: "휴대폰 번호를 입력하시면 PIN 재설정을 위한 인증번호를 보내드립니다.",
    new_pin_label: "새 4자리 PIN",
    verify_reset: "인증 후 PIN 재설정",
    verify_continue: "인증 후 계속",
    verify_your_mobile: "휴대폰 인증",
    migrate_title: "일회성 보안 인증",
    migrate_desc: "보안을 위해 이제 SMS로 휴대폰을 인증합니다. 아래를 눌러 인증번호를 받으세요.",
    resend_code: "인증번호 재전송",
    resend_in: "{s}초 후 재전송",
    complete_security_check: "보안 확인을 완료해 주세요",

    err_name: "성명을 입력해 주세요",
    err_phone: "유효한 휴대폰 번호를 입력해 주세요",
    err_address: "작업 주소를 입력해 주세요",
    err_pin4: "PIN은 정확히 4자리 숫자여야 합니다",
    toast_code_sent: "인증번호가 전송되었습니다",
    err_code6: "6자리 인증번호를 입력하세요",
    toast_account_created: "계정이 생성되었습니다!",
    err_enter_mobile: "휴대폰 번호를 입력하세요",
    err_enter_pin: "4자리 PIN을 입력하세요",
    welcome_name: "{name}님, 다시 오신 것을 환영합니다!",

    signed_in: "로그인됨",
    how_urgent: "작업이 얼마나 급하신가요?",
    choose_to_start: "견적 요청을 시작하려면 하나를 선택하세요.",
    urgent: "긴급",
    urgent_desc: "가능한 한 빨리 처리가 필요합니다",
    not_urgent: "급하지 않음",
    not_urgent_desc: "일정은 유연하게 가능합니다",

    quote_request: "견적 요청",
    required_note: "작업 종류, 완료 시기, 주소만 필수입니다.",
    type_of_work: "작업 종류",
    preferred_time: "희망 완료 시기",
    budget_label: "예상 예산 (NZD)",
    optional: "— 선택",
    budget_ph: "예: $500",
    description_label: "작업 설명",
    description_ph: "작업에 대해 더 알려주세요...",
    photos_videos: "사진 및 동영상",
    tap_add_media: "사진이나 동영상을 추가하려면 탭하세요",
    uploading: "업로드 중...",
    submit_request: "견적 요청 제출",
    err_select_work: "작업 종류를 선택해 주세요",
    err_select_time: "희망 완료 시기를 선택해 주세요",
    err_confirm_address: "작업 주소를 확인해 주세요",

    request_received: "요청이 접수되었습니다",
    thanks_touch: "감사합니다! MR SHU에서 곧 연락드리겠습니다.",
    job_reference: "작업 참조 번호",
    urgency: "긴급도",
    uploaded_files: "업로드된 파일",
    files_count: "{n}개 파일",
    submit_another: "다른 요청 제출",
    back_home: "홈으로",

    required_mark: "*",
  },
};

// Work categories — keyed by canonical English value (what is stored/sent to backend).
export const WORKTYPE_LABELS = {
  "Repairs & Handyman Services": { en: "Repairs & Handyman Services", "zh-CN": "维修与家庭维修服务", "zh-TW": "維修與家居維修服務", ko: "수리 및 핸디맨 서비스" },
  "Installation & Assembly": { en: "Installation & Assembly", "zh-CN": "安装与组装", "zh-TW": "安裝與組裝", ko: "설치 및 조립" },
  "Painting & Decorating": { en: "Painting & Decorating", "zh-CN": "油漆与装饰", "zh-TW": "油漆與裝飾", ko: "페인팅 및 장식" },
  "Exterior Cleaning & Roof Care": { en: "Exterior Cleaning & Roof Care", "zh-CN": "外墙清洁与屋顶护理", "zh-TW": "外牆清潔與屋頂護理", ko: "외부 청소 및 지붕 관리" },
  "Garden & Outdoor Maintenance": { en: "Garden & Outdoor Maintenance", "zh-CN": "花园与户外维护", "zh-TW": "花園與戶外維護", ko: "정원 및 실외 관리" },
  "Kitchen, Bathroom & Renovations": { en: "Kitchen, Bathroom & Renovations", "zh-CN": "厨房、浴室与翻新", "zh-TW": "廚房、浴室與翻新", ko: "주방, 욕실 및 리노베이션" },
  "Licensed Plumbing & Electrical Coordination": { en: "Licensed Plumbing & Electrical Coordination", "zh-CN": "持牌水管与电工协调", "zh-TW": "持牌水管與電工協調", ko: "면허 배관 및 전기 조율" },
  "Rental & Commercial Property Maintenance": { en: "Rental & Commercial Property Maintenance", "zh-CN": "出租与商业物业维护", "zh-TW": "出租與商業物業維護", ko: "임대 및 상업용 부동산 관리" },
  Other: { en: "Other", "zh-CN": "其他", "zh-TW": "其他", ko: "기타" },
  "Mobile Vehicle Oil & Filter Change": {
    en: "Mobile Vehicle Oil & Filter Change",
    "zh-CN": "上门汽车机油及机油滤芯更换",
    "zh-TW": "上門汽車機油及機油濾芯更換",
    ko: "방문 엔진오일 및 오일 필터 교환",
  },
};

// Completion times — keyed by canonical English value.
export const COMPLETION_LABELS = {
  "As soon as possible": { en: "As soon as possible", "zh-CN": "尽快", "zh-TW": "盡快", ko: "가능한 한 빨리" },
  "Within 24 hours": { en: "Within 24 hours", "zh-CN": "24 小时内", "zh-TW": "24 小時內", ko: "24시간 이내" },
  "Within a few days": { en: "Within a few days", "zh-CN": "几天内", "zh-TW": "幾天內", ko: "며칠 이내" },
  "Within a week": { en: "Within a week", "zh-CN": "一周内", "zh-TW": "一週內", ko: "일주일 이내" },
  "Within 2 weeks": { en: "Within 2 weeks", "zh-CN": "两周内", "zh-TW": "兩週內", ko: "2주 이내" },
  "This month": { en: "This month", "zh-CN": "本月内", "zh-TW": "本月內", ko: "이번 달 내" },
  "Flexible / no rush": { en: "Flexible / no rush", "zh-CN": "时间灵活 / 不急", "zh-TW": "時間彈性 / 不急", ko: "유연함 / 급하지 않음" },
};

// Backend error messages mapped to translations (frontend display only).
const SERVER_ERRORS = {
  "zh-CN": {
    "Incorrect PIN": "密码错误",
    "No account found for this mobile number": "未找到该手机号码的账户",
    "This mobile number is already registered. Please log in.": "该手机号码已注册，请登录。",
    "Invalid verification code": "验证码无效",
    "PIN must be exactly 4 digits": "密码必须是 4 位数字",
    "Too many failed attempts. Account locked for 5 minutes.": "尝试次数过多。账户已锁定 5 分钟。",
    "Invalid admin credentials": "管理员凭据无效",
    lockout_seconds: "尝试次数过多。请在 {s} 秒后重试。",
  },
  "zh-TW": {
    "Incorrect PIN": "密碼錯誤",
    "No account found for this mobile number": "找不到此手機號碼的帳戶",
    "This mobile number is already registered. Please log in.": "此手機號碼已註冊，請登入。",
    "Invalid verification code": "驗證碼無效",
    "PIN must be exactly 4 digits": "密碼必須是 4 位數字",
    "Too many failed attempts. Account locked for 5 minutes.": "嘗試次數過多。帳戶已鎖定 5 分鐘。",
    "Invalid admin credentials": "管理員憑據無效",
    lockout_seconds: "嘗試次數過多。請在 {s} 秒後重試。",
  },
  ko: {
    "Incorrect PIN": "PIN이 올바르지 않습니다",
    "No account found for this mobile number": "이 번호로 등록된 계정을 찾을 수 없습니다",
    "This mobile number is already registered. Please log in.": "이미 등록된 번호입니다. 로그인해 주세요.",
    "Invalid verification code": "인증번호가 올바르지 않습니다",
    "PIN must be exactly 4 digits": "PIN은 정확히 4자리 숫자여야 합니다",
    "Too many failed attempts. Account locked for 5 minutes.": "시도 횟수가 너무 많습니다. 계정이 5분간 잠겼습니다.",
    "Invalid admin credentials": "관리자 자격 증명이 올바르지 않습니다",
    lockout_seconds: "시도 횟수가 너무 많습니다. {s}초 후에 다시 시도하세요.",
  },
};

function interpolate(str, vars) {
  if (!vars) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
}

// Additional strings introduced by the coordinated update (branding, home, portal,
// messaging, appointments). Merged on top of STRINGS in makeT.
const EXTRA = {
  en: {
    brand_subtitle: "Property Repairs, Maintenance & Improvements across Christchurch",
    min_tagline: "Handyman & Property Maintenance",
    follow_up: "Follow Up", mark_follow_up: "Mark for Follow Up", remove_follow_up: "Remove Follow Up",
    awaiting_reply: "Awaiting Reply", no_reply_needed: "No Reply Needed", internal_notes: "Internal notes",
    my_profile: "My Profile", edit_name: "Name", preferred_language: "Preferred language",
    change_phone: "Change phone number", new_phone: "New mobile number", verify_change: "Verify & change",
    save: "Save", saved: "Saved", cancel: "Cancel", member_since: "Member since",
    manage_properties: "My Properties", add_property: "Add property", edit_property: "Edit property",
    property_nickname: "Nickname", property_type: "Property type", unit_shop: "Unit / shop number",
    access_notes: "Access instructions", contact_person: "Contact person", contact_phone: "Contact phone",
    set_default: "Set as default", default_label: "Default", archive_label: "Archive",
    archived_label: "Archived", select_property: "Select a saved property",
    add_new_property: "Enter a new address", no_properties: "No properties yet.",
    cta_request_quote: "Request a Quote",
    service_area: "Serving Christchurch and surrounding areas. Travel charges may apply outside the standard service area.",
    my_requests: "My Requests", home_title: "Your account", new_messages: "New messages",
    no_requests: "You have no requests yet.", submitted_on: "Submitted", last_updated: "Last updated",
    status_label: "Status", ref_label: "Reference", view_details: "View details",
    request_detail: "Request details", status_history: "Status history",
    conversation: "Messages", type_a_message: "Type a message…", send: "Send",
    no_messages: "No messages yet. Start the conversation below.",
    by_you: "You", by_admin: "MR SHU Handyman", unread: "unread",
    cancel_request: "Cancel this request",
    cancel_title: "Cancel this request?",
    cancel_message: "This request will be cancelled but kept in your history. Any scheduled visit will also be cancelled.",
    cancel_reason_ph: "Reason for cancelling (optional)",
    keep_request: "Keep request",
    confirm_cancellation: "Confirm cancellation",
    cancellation_reason_label: "Cancellation reason",
    cancelled_on: "Cancelled on",
    cancel_done: "Your request has been cancelled",
    mobile_service_badge: "Mobile Service",
    vehicle_service_desc: "We come to your home or workplace in Christchurch to replace the engine oil and oil filter in petrol, petrol-hybrid and diesel vehicles. Spark-plug replacement can also be requested. Evening appointments may be available by arrangement.",
    vehicle_scope_note: "A convenient mobile service at your home or workplace — no need to leave your vehicle at a workshop. Appointments remain subject to location, access and availability. This is not roadside assistance, and not a full vehicle inspection, diagnostic or manufacturer-scheduled service. Current scope: engine oil, oil filter and optional spark plugs.",
    vehicle_details: "Vehicle details",
    plate_label: "Registration plate",
    fuel_type: "Fuel type",
    fuel_placeholder: "Select fuel type",
    "fuel_Petrol": "Petrol",
    "fuel_Petrol hybrid": "Petrol hybrid",
    "fuel_Diesel": "Diesel",
    "fuel_Unsure": "Unsure",
    odometer_label: "Current odometer (km)",
    make_model_year: "Make, model and year (if known)",
    spark_plug_opt: "I would also like a quote for spark-plug replacement",
    parking_notes: "Parking or access instructions",
    safe_location_confirm: "I confirm the vehicle can be parked on a safe, level, solid, off-street surface with sufficient working space.",
    plate_privacy_notice: "We collect your vehicle registration to identify the vehicle, confirm suitable oil and parts, prepare your quotation, arrange the service and maintain the job record. It may be shared with the assigned service provider and relevant parts supplier only for these purposes. Without it, we cannot process a vehicle-service request.",
    enquiry_notice: "Submitting this request does not create a contract or confirmed booking. We will review the job or vehicle details and contact you to confirm the work, final price and appointment before work begins. No additional work or charges will proceed without your approval. Your statutory rights under New Zealand consumer law are not affected.",
    requests_info_title: "Requests and quotations",
    legal_operator_note: "MRSHU.CO.NZ is operated by MR SHU LIMITED as a marketing and enquiry platform. The legal service provider will be clearly identified in the formal quote or booking confirmation and invoice.",
    spark_quote_requested: "Spark-plug quotation requested",
    service_location: "Service location",
    odometer_display: "Odometer",
    yes: "Yes",
    no: "No",
    err_plate_required: "Please enter the vehicle registration plate",
    err_safe_location: "Please confirm the vehicle can be parked safely",
    err_select_fuel: "Please select a fuel type",
    appointment: "Appointment", visit_section_title: "Would you like to request a visit?",
    visit_optional_note: "Optional. MR SHU Handyman may still require an inspection, extra information, materials or specialist coordination before starting work.",
    preferred_visit_times: "Preferred visit times (up to 3)",
    add_time: "Add a time", remove: "Remove", preferred_date: "Preferred date",
    time_period: "Time of day", exact_note: "Exact time / availability note (optional)",
    request_only_note: "Your selected time is a request only and is not confirmed until MR SHU Handyman confirms it.",
    proposed_time: "Proposed time", confirmed_time: "Confirmed appointment", requested_time: "Requested",
    accept_time: "Accept this time", request_different: "Request a different time",
    appt_type: "Visit type", none_yet: "None yet",
    back_to_home: "Back to home", loading: "Loading…",
  },
  "zh-CN": {
    brand_subtitle: "基督城房产维修、维护与改善服务",
    min_tagline: "维修与物业维护",
    follow_up: "跟进", mark_follow_up: "标记为跟进", remove_follow_up: "取消跟进",
    awaiting_reply: "待回复", no_reply_needed: "无需回复", internal_notes: "内部备注",
    my_profile: "我的资料", edit_name: "姓名", preferred_language: "首选语言",
    change_phone: "更改手机号码", new_phone: "新手机号码", verify_change: "验证并更改",
    save: "保存", saved: "已保存", cancel: "取消", member_since: "注册于",
    manage_properties: "我的物业", add_property: "添加物业", edit_property: "编辑物业",
    property_nickname: "昵称", property_type: "物业类型", unit_shop: "单元／店铺号",
    access_notes: "进入说明", contact_person: "联系人", contact_phone: "联系电话",
    set_default: "设为默认", default_label: "默认", archive_label: "归档",
    archived_label: "已归档", select_property: "选择已保存物业",
    add_new_property: "输入新地址", no_properties: "暂无物业。",
    cta_request_quote: "申请报价",
    service_area: "服务基督城及周边地区。标准服务区以外可能收取交通费。",
    my_requests: "我的申请", home_title: "您的账户", new_messages: "新消息",
    no_requests: "您还没有任何申请。", submitted_on: "提交于", last_updated: "最近更新",
    status_label: "状态", ref_label: "编号", view_details: "查看详情",
    request_detail: "申请详情", status_history: "状态历史",
    conversation: "消息", type_a_message: "输入消息……", send: "发送",
    no_messages: "还没有消息。在下方开始对话吧。",
    by_you: "您", by_admin: "MR SHU Handyman", unread: "未读",
    cancel_request: "取消此请求",
    cancel_title: "确定取消此请求？",
    cancel_message: "此请求将被取消，但会保留在您的历史记录中。任何已安排的上门也将一并取消。",
    cancel_reason_ph: "取消原因（可选）",
    keep_request: "保留请求",
    confirm_cancellation: "确认取消",
    cancellation_reason_label: "取消原因",
    cancelled_on: "取消时间",
    cancel_done: "您的请求已取消",
    mobile_service_badge: "上门服务",
    vehicle_service_desc: "我们上门到您在基督城的住所或工作地点，为汽油、油电混合及柴油车辆更换发动机机油和机油滤芯。也可申请更换火花塞。晚间预约或可另行安排。",
    vehicle_scope_note: "这是在您住所或工作地点的便捷上门服务——无需将车辆留在维修厂。预约仍取决于地点、通道及可用性。此服务并非道路救援，也不是完整车辆检查、诊断或原厂定期保养。当前范围：发动机机油、机油滤芯及可选的火花塞。",
    vehicle_details: "车辆信息",
    plate_label: "车牌号码",
    fuel_type: "燃料类型",
    fuel_placeholder: "请选择燃料类型",
    "fuel_Petrol": "汽油",
    "fuel_Petrol hybrid": "汽油油电混合",
    "fuel_Diesel": "柴油",
    "fuel_Unsure": "不确定",
    odometer_label: "当前里程（公里）",
    make_model_year: "品牌、型号及年份（如知道）",
    spark_plug_opt: "我也想获取更换火花塞的报价",
    parking_notes: "停车或通道说明",
    safe_location_confirm: "我确认车辆可停放在安全、平整、坚实的非路边场地，并有足够的作业空间。",
    plate_privacy_notice: "我们收集您的车牌以识别车辆、确认合适的机油和配件、准备报价、安排服务并保存工作记录。仅为上述目的，可能与指派的服务提供者及相关配件供应商共享。若不提供，我们将无法处理车辆服务请求。",
    enquiry_notice: "提交此请求并不构成合同或确认预约。我们会审核工作或车辆信息，并在开始工作前联系您确认工作内容、最终价格和预约时间。未经您的批准，不会进行任何额外工作或收费。您在新西兰消费者法下的法定权利不受影响。",
    requests_info_title: "请求与报价",
    legal_operator_note: "MRSHU.CO.NZ 由 MR SHU LIMITED 作为营销与咨询平台运营。法定服务提供者将在正式报价或预约确认及发票中明确标明。",
    spark_quote_requested: "已申请火花塞报价",
    service_location: "服务地点",
    odometer_display: "里程",
    yes: "是",
    no: "否",
    err_plate_required: "请输入车牌号码",
    err_safe_location: "请确认车辆可安全停放",
    err_select_fuel: "请选择燃料类型",
    appointment: "预约", visit_section_title: "您需要预约上门吗？",
    visit_optional_note: "可选。MR SHU Handyman 在开工前可能仍需进行检查、了解更多信息、准备材料或协调专业人员。",
    preferred_visit_times: "期望上门时间（最多 3 个）",
    add_time: "添加时间", remove: "移除", preferred_date: "期望日期",
    time_period: "时间段", exact_note: "具体时间／可用时间备注（可选）",
    request_only_note: "您所选的时间仅为申请，在 MR SHU Handyman 确认之前并非最终确认。",
    proposed_time: "建议时间", confirmed_time: "已确认预约", requested_time: "已申请",
    accept_time: "接受此时间", request_different: "申请其他时间",
    appt_type: "上门类型", none_yet: "暂无",
    back_to_home: "返回首页", loading: "加载中……",
  },
  "zh-TW": {
    brand_subtitle: "基督城房產維修、維護與改善服務",
    min_tagline: "維修與物業維護",
    follow_up: "跟進", mark_follow_up: "標記為跟進", remove_follow_up: "取消跟進",
    awaiting_reply: "待回覆", no_reply_needed: "無需回覆", internal_notes: "內部備註",
    my_profile: "我的資料", edit_name: "姓名", preferred_language: "偏好語言",
    change_phone: "更改手機號碼", new_phone: "新手機號碼", verify_change: "驗證並更改",
    save: "儲存", saved: "已儲存", cancel: "取消", member_since: "註冊於",
    manage_properties: "我的物業", add_property: "新增物業", edit_property: "編輯物業",
    property_nickname: "暱稱", property_type: "物業類型", unit_shop: "單位／店舖號",
    access_notes: "進入說明", contact_person: "聯絡人", contact_phone: "聯絡電話",
    set_default: "設為預設", default_label: "預設", archive_label: "封存",
    archived_label: "已封存", select_property: "選擇已儲存物業",
    add_new_property: "輸入新地址", no_properties: "暫無物業。",
    cta_request_quote: "申請報價",
    service_area: "服務基督城及周邊地區。標準服務區以外可能收取交通費。",
    my_requests: "我的申請", home_title: "您的帳戶", new_messages: "新訊息",
    no_requests: "您還沒有任何申請。", submitted_on: "提交於", last_updated: "最近更新",
    status_label: "狀態", ref_label: "編號", view_details: "查看詳情",
    request_detail: "申請詳情", status_history: "狀態歷史",
    conversation: "訊息", type_a_message: "輸入訊息……", send: "傳送",
    no_messages: "還沒有訊息。在下方開始對話吧。",
    by_you: "您", by_admin: "MR SHU Handyman", unread: "未讀",
    cancel_request: "取消此請求",
    cancel_title: "確定取消此請求？",
    cancel_message: "此請求將被取消，但會保留在您的歷史記錄中。任何已安排的上門也將一併取消。",
    cancel_reason_ph: "取消原因（可選）",
    keep_request: "保留請求",
    confirm_cancellation: "確認取消",
    cancellation_reason_label: "取消原因",
    cancelled_on: "取消時間",
    cancel_done: "您的請求已取消",
    mobile_service_badge: "上門服務",
    vehicle_service_desc: "我們上門到您在基督城的住所或工作地點，為汽油、油電混合及柴油車輛更換引擎機油和機油濾芯。亦可申請更換火花塞。晚間預約或可另行安排。",
    vehicle_scope_note: "這是在您住所或工作地點的便捷上門服務——無需將車輛留在維修廠。預約仍取決於地點、通道及可用性。此服務並非道路救援，也不是完整車輛檢查、診斷或原廠定期保養。目前範圍：引擎機油、機油濾芯及可選的火花塞。",
    vehicle_details: "車輛資料",
    plate_label: "車牌號碼",
    fuel_type: "燃料類型",
    fuel_placeholder: "請選擇燃料類型",
    "fuel_Petrol": "汽油",
    "fuel_Petrol hybrid": "汽油油電混合",
    "fuel_Diesel": "柴油",
    "fuel_Unsure": "不確定",
    odometer_label: "目前里程（公里）",
    make_model_year: "品牌、型號及年份（如知道）",
    spark_plug_opt: "我也想取得更換火花塞的報價",
    parking_notes: "停車或通道說明",
    safe_location_confirm: "我確認車輛可停放在安全、平整、堅實的非路邊場地，並有足夠的作業空間。",
    plate_privacy_notice: "我們收集您的車牌以識別車輛、確認合適的機油和配件、準備報價、安排服務並保存工作記錄。僅為上述目的，可能與指派的服務提供者及相關配件供應商共享。若不提供，我們將無法處理車輛服務請求。",
    enquiry_notice: "提交此請求並不構成合約或確認預約。我們會審核工作或車輛資料，並在開始工作前聯絡您確認工作內容、最終價格和預約時間。未經您的批准，不會進行任何額外工作或收費。您在紐西蘭消費者法下的法定權利不受影響。",
    requests_info_title: "請求與報價",
    legal_operator_note: "MRSHU.CO.NZ 由 MR SHU LIMITED 作為營銷與諮詢平台營運。法定服務提供者將在正式報價或預約確認及發票中明確標明。",
    spark_quote_requested: "已申請火花塞報價",
    service_location: "服務地點",
    odometer_display: "里程",
    yes: "是",
    no: "否",
    err_plate_required: "請輸入車牌號碼",
    err_safe_location: "請確認車輛可安全停放",
    err_select_fuel: "請選擇燃料類型",
    appointment: "預約", visit_section_title: "您需要預約上門嗎？",
    visit_optional_note: "選填。MR SHU Handyman 在開工前可能仍需進行檢查、了解更多資訊、準備材料或協調專業人員。",
    preferred_visit_times: "期望上門時間（最多 3 個）",
    add_time: "新增時間", remove: "移除", preferred_date: "期望日期",
    time_period: "時段", exact_note: "具體時間／可用時間備註（選填）",
    request_only_note: "您所選的時間僅為申請，在 MR SHU Handyman 確認之前並非最終確認。",
    proposed_time: "建議時間", confirmed_time: "已確認預約", requested_time: "已申請",
    accept_time: "接受此時間", request_different: "申請其他時間",
    appt_type: "上門類型", none_yet: "暫無",
    back_to_home: "返回首頁", loading: "載入中……",
  },
  ko: {
    brand_subtitle: "크라이스트처치 전역의 부동산 수리, 유지보수 및 개선 서비스",
    min_tagline: "핸디맨 및 부동산 관리",
    follow_up: "후속 조치", mark_follow_up: "후속 조치 표시", remove_follow_up: "후속 조치 해제",
    awaiting_reply: "답장 대기", no_reply_needed: "답장 불필요", internal_notes: "내부 메모",
    my_profile: "내 프로필", edit_name: "이름", preferred_language: "선호 언어",
    change_phone: "전화번호 변경", new_phone: "새 휴대폰 번호", verify_change: "인증 후 변경",
    save: "저장", saved: "저장됨", cancel: "취소", member_since: "가입일",
    manage_properties: "내 자산", add_property: "자산 추가", edit_property: "자산 편집",
    property_nickname: "별칭", property_type: "자산 유형", unit_shop: "호수 / 상점 번호",
    access_notes: "출입 안내", contact_person: "담당자", contact_phone: "연락처",
    set_default: "기본으로 설정", default_label: "기본", archive_label: "보관",
    archived_label: "보관됨", select_property: "저장된 자산 선택",
    add_new_property: "새 주소 입력", no_properties: "아직 자산이 없습니다.",
    cta_request_quote: "견적 요청",
    service_area: "크라이스트처치 및 인근 지역 서비스. 표준 서비스 지역 외에는 출장비가 부과될 수 있습니다.",
    my_requests: "내 요청", home_title: "내 계정", new_messages: "새 메시지",
    no_requests: "아직 요청이 없습니다.", submitted_on: "제출일", last_updated: "최근 업데이트",
    status_label: "상태", ref_label: "참조번호", view_details: "상세 보기",
    request_detail: "요청 상세", status_history: "상태 기록",
    conversation: "메시지", type_a_message: "메시지를 입력하세요…", send: "보내기",
    no_messages: "아직 메시지가 없습니다. 아래에서 대화를 시작하세요.",
    by_you: "나", by_admin: "MR SHU Handyman", unread: "읽지 않음",
    cancel_request: "이 요청 취소",
    cancel_title: "이 요청을 취소할까요?",
    cancel_message: "이 요청은 취소되지만 기록에는 남습니다. 예정된 방문도 함께 취소됩니다.",
    cancel_reason_ph: "취소 사유 (선택 사항)",
    keep_request: "요청 유지",
    confirm_cancellation: "취소 확정",
    cancellation_reason_label: "취소 사유",
    cancelled_on: "취소 일시",
    cancel_done: "요청이 취소되었습니다",
    mobile_service_badge: "방문 서비스",
    vehicle_service_desc: "크라이스트처치의 자택이나 직장으로 방문하여 가솔린, 가솔린 하이브리드, 디젤 차량의 엔진오일과 오일 필터를 교환해 드립니다. 스파크 플러그 교환도 요청하실 수 있습니다. 저녁 예약은 사전 협의 시 가능할 수 있습니다.",
    vehicle_scope_note: "자택이나 직장에서 받는 편리한 방문 서비스로, 차량을 정비소에 맡기실 필요가 없습니다. 예약은 위치, 접근성 및 가용성에 따라 달라집니다. 이는 긴급 도로 서비스가 아니며, 전체 차량 점검·진단·제조사 정기 정비도 아닙니다. 현재 범위: 엔진오일, 오일 필터 및 선택 사항인 스파크 플러그.",
    vehicle_details: "차량 정보",
    plate_label: "차량 번호판",
    fuel_type: "연료 유형",
    fuel_placeholder: "연료 유형 선택",
    "fuel_Petrol": "가솔린",
    "fuel_Petrol hybrid": "가솔린 하이브리드",
    "fuel_Diesel": "디젤",
    "fuel_Unsure": "잘 모름",
    odometer_label: "현재 주행거리 (km)",
    make_model_year: "제조사, 모델 및 연식 (아는 경우)",
    spark_plug_opt: "스파크 플러그 교환 견적도 원합니다",
    parking_notes: "주차 또는 접근 안내",
    safe_location_confirm: "차량을 안전하고 평평하며 단단한 사유지 노외 공간에 충분한 작업 공간과 함께 주차할 수 있음을 확인합니다.",
    plate_privacy_notice: "차량을 식별하고 적합한 오일과 부품을 확인하며 견적을 준비하고 서비스를 예약하며 작업 기록을 유지하기 위해 차량 번호판을 수집합니다. 이러한 목적에 한하여 배정된 서비스 제공자 및 관련 부품 공급업체와 공유될 수 있습니다. 제공하지 않으시면 차량 서비스 요청을 처리할 수 없습니다.",
    enquiry_notice: "이 요청을 제출해도 계약이나 확정 예약이 성립되지 않습니다. 작업 시작 전에 작업 또는 차량 정보를 검토하고 연락드려 작업 내용, 최종 가격 및 예약을 확인합니다. 귀하의 승인 없이 추가 작업이나 비용은 진행되지 않습니다. 뉴질랜드 소비자법상의 법적 권리는 영향을 받지 않습니다.",
    requests_info_title: "요청 및 견적",
    legal_operator_note: "MRSHU.CO.NZ는 MR SHU LIMITED가 마케팅 및 문의 플랫폼으로 운영합니다. 법적 서비스 제공자는 공식 견적서 또는 예약 확인서 및 청구서에 명확히 표시됩니다.",
    spark_quote_requested: "스파크 플러그 견적 요청됨",
    service_location: "서비스 위치",
    odometer_display: "주행거리",
    yes: "예",
    no: "아니오",
    err_plate_required: "차량 번호판을 입력해 주세요",
    err_safe_location: "차량을 안전하게 주차할 수 있음을 확인해 주세요",
    err_select_fuel: "연료 유형을 선택해 주세요",
    appointment: "예약", visit_section_title: "방문을 요청하시겠어요?",
    visit_optional_note: "선택 사항입니다. MR SHU Handyman은 작업 시작 전 점검, 추가 정보, 자재 또는 전문가 조율이 필요할 수 있습니다.",
    preferred_visit_times: "희망 방문 시간 (최대 3개)",
    add_time: "시간 추가", remove: "삭제", preferred_date: "희망 날짜",
    time_period: "시간대", exact_note: "정확한 시간 / 가능 시간 메모 (선택)",
    request_only_note: "선택하신 시간은 요청일 뿐이며 MR SHU Handyman이 확정하기 전까지는 확정되지 않습니다.",
    proposed_time: "제안된 시간", confirmed_time: "확정된 예약", requested_time: "요청됨",
    accept_time: "이 시간 수락", request_different: "다른 시간 요청",
    appt_type: "방문 유형", none_yet: "아직 없음",
    back_to_home: "홈으로", loading: "로딩 중…",
  },
};

// Customer-visible job statuses.
export const STATUS_LABELS = {
  Submitted: { en: "Submitted", "zh-CN": "已提交", "zh-TW": "已提交", ko: "제출됨" },
  Reviewing: { en: "Reviewing", "zh-CN": "审核中", "zh-TW": "審核中", ko: "검토 중" },
  "Need More Information": { en: "Need More Information", "zh-CN": "需要更多信息", "zh-TW": "需要更多資訊", ko: "추가 정보 필요" },
  "Visit Requested": { en: "Visit Requested", "zh-CN": "已申请上门", "zh-TW": "已申請上門", ko: "방문 요청됨" },
  "Visit Proposed": { en: "Visit Proposed", "zh-CN": "已建议上门时间", "zh-TW": "已建議上門時間", ko: "방문 시간 제안됨" },
  "Visit Confirmed": { en: "Visit Confirmed", "zh-CN": "上门已确认", "zh-TW": "上門已確認", ko: "방문 확정됨" },
  "Quote Preparing": { en: "Quote Preparing", "zh-CN": "报价准备中", "zh-TW": "報價準備中", ko: "견적 준비 중" },
  "Quote Sent": { en: "Quote Sent", "zh-CN": "报价已发送", "zh-TW": "報價已發送", ko: "견적 발송됨" },
  Accepted: { en: "Accepted", "zh-CN": "已接受", "zh-TW": "已接受", ko: "수락됨" },
  Scheduled: { en: "Scheduled", "zh-CN": "已排期", "zh-TW": "已排期", ko: "일정 확정" },
  "In Progress": { en: "In Progress", "zh-CN": "进行中", "zh-TW": "進行中", ko: "진행 중" },
  Completed: { en: "Completed", "zh-CN": "已完成", "zh-TW": "已完成", ko: "완료됨" },
  Cancelled: { en: "Cancelled", "zh-CN": "已取消", "zh-TW": "已取消", ko: "취소됨" },
  customer_cancelled: { en: "Cancelled by you", "zh-CN": "您已取消", "zh-TW": "您已取消", ko: "직접 취소함" },
};

export const VISIT_LABELS = {
  "Contact me first / No time preference": { en: "Contact me first / No time preference", "zh-CN": "请先联系我 / 无时间偏好", "zh-TW": "請先聯絡我 / 無時間偏好", ko: "먼저 연락 주세요 / 시간 무관" },
  "On-site inspection": { en: "On-site inspection", "zh-CN": "现场检查", "zh-TW": "現場檢查", ko: "현장 점검" },
  "Ready for work visit": { en: "Ready for work visit", "zh-CN": "可直接施工上门", "zh-TW": "可直接施工上門", ko: "작업 방문 준비 완료" },
  "As soon as possible": { en: "As soon as possible", "zh-CN": "尽快", "zh-TW": "盡快", ko: "가능한 한 빨리" },
};

export const PERIOD_LABELS = {
  Morning: { en: "Morning (8am–12pm)", "zh-CN": "上午（8:00–12:00）", "zh-TW": "上午（8:00–12:00）", ko: "오전 (8시–12시)" },
  Afternoon: { en: "Afternoon (12pm–5pm)", "zh-CN": "下午（12:00–17:00）", "zh-TW": "下午（12:00–17:00）", ko: "오후 (12시–5시)" },
  Flexible: { en: "Flexible", "zh-CN": "时间灵活", "zh-TW": "時間彈性", ko: "유연함" },
};

export function makeT(lang) {
  return (key, vars) =>
    interpolate(EXTRA[lang]?.[key] ?? STRINGS[lang]?.[key] ?? EXTRA.en[key] ?? STRINGS.en[key] ?? key, vars);
}

export function tStatus(value, lang) {
  return STATUS_LABELS[value]?.[lang] ?? value;
}
export function tVisit(value, lang) {
  return VISIT_LABELS[value]?.[lang] ?? value;
}
export function tPeriod(value, lang) {
  return PERIOD_LABELS[value]?.[lang] ?? value;
}

export const PROPERTY_TYPE_LABELS = {
  "Home": { en: "Home", "zh-CN": "住宅", "zh-TW": "住宅", ko: "주택" },
  "Apartment": { en: "Apartment", "zh-CN": "公寓", "zh-TW": "公寓", ko: "아파트" },
  "Rental Property": { en: "Rental Property", "zh-CN": "出租物业", "zh-TW": "出租物業", ko: "임대 부동산" },
  "Airbnb / Short-stay": { en: "Airbnb / Short-stay", "zh-CN": "民宿／短租", "zh-TW": "民宿／短租", ko: "에어비앤비/단기임대" },
  "Retail Shop": { en: "Retail Shop", "zh-CN": "零售店铺", "zh-TW": "零售店舖", ko: "소매점" },
  "Office": { en: "Office", "zh-CN": "办公室", "zh-TW": "辦公室", ko: "사무실" },
  "Commercial Property": { en: "Commercial Property", "zh-CN": "商业物业", "zh-TW": "商業物業", ko: "상업용 부동산" },
  "Body Corporate / Common Area": { en: "Body Corporate / Common Area", "zh-CN": "业主立案法团／公共区域", "zh-TW": "業主立案法團／公共區域", ko: "집합건물/공용구역" },
  "Other": { en: "Other", "zh-CN": "其他", "zh-TW": "其他", ko: "기타" },
};

export function tPropType(value, lang) {
  return PROPERTY_TYPE_LABELS[value]?.[lang] ?? value;
}

export function tWork(value, lang) {
  return WORKTYPE_LABELS[value]?.[lang] ?? value;
}

export function tCompletion(value, lang) {
  return COMPLETION_LABELS[value]?.[lang] ?? value;
}

export function translateServerError(msg, lang) {
  if (!msg || lang === "en") return msg;
  const table = SERVER_ERRORS[lang];
  if (!table) return msg;
  const sec = msg.match(/Locked for (\d+) more seconds/);
  if (sec) return interpolate(table.lockout_seconds, { s: sec[1] });
  return table[msg] ?? msg;
}
